import { render, staticRenderFns } from "./mspType.vue?vue&type=template&id=6ca41894&scoped=true&"
import script from "./mspType.vue?vue&type=script&lang=js&"
export * from "./mspType.vue?vue&type=script&lang=js&"
import style0 from "./mspType.vue?vue&type=style&index=0&id=6ca41894&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca41894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca41894')) {
      api.createRecord('6ca41894', component.options)
    } else {
      api.reload('6ca41894', component.options)
    }
    module.hot.accept("./mspType.vue?vue&type=template&id=6ca41894&scoped=true&", function () {
      api.rerender('6ca41894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/shortResume/mspType.vue"
export default component.exports